// Server component with a CSS entrance (.enter in globals.css) instead of
// framer-motion: the <h1> is usually the page's LCP element and must be
// visible from the first paint rather than after JS hydration.
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  divider = true,
}: {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  divider?: boolean;
}) {
  return (
    <section className={`bg-paper ${divider ? "border-b border-line" : ""}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-20 pb-14 sm:pb-16">
        <div className="flex flex-col items-center text-center gap-5">
          <p className="enter text-xs font-bold uppercase tracking-widest text-ink-faint">
            {eyebrow}
          </p>
          <h1 className="enter [--enter-delay:90ms] font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.1] text-ink">
            {title}
          </h1>
          {subtitle && (
            <p className="enter [--enter-delay:180ms] text-lg text-ink-soft leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
